import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SubscriptionSaleBadgeProps extends BadgeProps {
  isSubscriptionSale?: boolean;
}

// A subscription sale is the first order of a Shopify subscription (renewals
// are never commissioned). Flag it so the brand can tell it from a one-off sale.
const SubscriptionSaleBadge: React.FC<SubscriptionSaleBadgeProps> = ({
  isSubscriptionSale,
  ...props
}) => {
  const { t } = useTranslation();

  if (!isSubscriptionSale) return null;

  return (
    <Badge size="xs" variant="subtle" colorPalette="gray" flexShrink={0} {...props}>
      {t('orders.subscription', 'Subscription')}
    </Badge>
  );
};

export default SubscriptionSaleBadge;
